import React, { useState, useEffect } from 'react';
import { apiService } from '../../services/api';
import { Category } from '../../types';
import { Spin } from 'antd';
import './MobileCategoryNav.css';

interface MobileCategoryNavProps {
  selectedCategoryId?: number;
}

const MobileCategoryNav: React.FC<MobileCategoryNavProps> = ({
  selectedCategoryId = 0
}) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const response = await apiService.getCategories();
      if (response.code === 0) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error('Failed to load categories:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mobile-category-nav">
      <div className="mobile-category-container">
        {loading ? (
          <div className="mobile-category-loading">
            <Spin size="small" />
          </div>
        ) : (
          <div className="mobile-category-scroll">
            {/* All Category */}
            <a
              href="/"
              className={`mobile-category-item ${selectedCategoryId === 0 ? 'mobile-category-item-active' : ''}`}
            >
              <span className="mobile-category-text">All</span>
            </a>

            {/* Other Categories */}
            {categories.map((category) => (
              <a
                key={category.id}
                href={`/category/${category.id}`}
                className={`mobile-category-item ${selectedCategoryId === category.id ? 'mobile-category-item-active' : ''}`}
              >
                <span className="mobile-category-text">{category.name}</span>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileCategoryNav;
